import constants from "../../../../../appConstants";
import {
  mergeUserConfig,
  formatDateTimeWithoutUTCConversion,
} from '@dataGrid/gridUtilities';
import {
  MultiSelectFilter,
  DateTimeFilter,
  StaticFilter,
} from '@dataGrid/components/columnFilters';
import DefectsDetails from "../Defects/DefectsDetails";
import {
  defectsFilterOptions,
  getDefectsFilterValue,
} from "../Defects/DefectsFilter";
import { getDefects, getScacValue } from "../utils/utils";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration({ showTrailerScacColumn, showTrailerScacValue, userConfig }) {
    const defaultConfig = GridConfig.getDefaultConfiguration(showTrailerScacColumn, showTrailerScacValue);
    return mergeUserConfig({
      defaultConfig,
      userConfig,
    });
  }

  static getDefaultConfiguration(showTrailerScacColumn, showTrailerScacValue) {
    return {
      title: constants.gridNames.DollyGrid,
      keyColumn: "dollyId",
      rowSelection:'single',
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Dolly #",
          headerTooltip: "Dolly #",
          field: "dollyNumber",
          pinned: "left",
          width: constants.columnWidth.W_110,
          minWidth: constants.columnWidth.W_110,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          cellRenderer: GridConfig.TrailerNumberRenderer,
        },
        {
          headerName: "SCAC Code",
          headerTooltip: "SCAC Code",
          field: "dollyScac",
          hide: !showTrailerScacColumn,
          isInvisibleInShowHide: !showTrailerScacColumn,
          shouldForceHideColumn: !showTrailerScacColumn,
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          valueGetter: getScacValue(showTrailerScacValue, 'dollyScac'),
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Dolly Status",
          headerTooltip: "Dolly Status",
          field: "dollyStatus",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_90,
          minWidth: constants.columnWidth.W_90,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Location",
          headerTooltip: "Location",
          field: "",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
          filterParams:{
            width: constants.columnWidth.W_300
          }
        },

        {
          headerName: "Current Terminal",
          headerTooltip: "Inbound Terminal",
          field: "inboundTerminal",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_90,
          minWidth: constants.columnWidth.W_90,
          cellClass: "gridCell-leftAlign",
        },

        {
          headerName: "Last Updated",
          headerTooltip: "Last Updated",
          field: "lastModifiedDateTs",
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME,
          },
          width: constants.columnWidth.W_90,
          cellClass: "gridCell-leftAlign",
          valueFormatter: formatDateTimeWithoutUTCConversion,
        },
        {
          headerName: "Defect",
          headerTooltip: "Defect",
          valueGetter: getDefects,
          cellRenderer: DefectsDetails,
          filter: StaticFilter,
          filterParams: {
            staticOptions: defectsFilterOptions,
            getValue: getDefectsFilterValue
          },
          sortable: false,
          width: constants.columnWidth.W_200,
          minWidth: constants.columnWidth.W_200,
          cellClass: "gridCell-leftAlign",
        },
      ],
    };
  }
}
